/**
 * Sessions
 *
 * A collection of re-usable functions that's used for session management
 *
 * @since 0.5
 * @package \app\abstract
 *
 */

import { getUrl } from "../globals/url";
import { getCurrentDate } from '../abstract/time';

/**
 * manageSession
 *
 * For check existing session, creating or deleting and redirects
 * user to the next step or thank you page
 *
 * @since 0.5
 *
 * @param {string} key The session key to check or create
 * @param {object} data The data use to be stored in the session
 * @param {string} redirectUrl Where to take the user next
 *
 * @return {n/a}
 *
 */
export function manageSession(key, data, currentStep, lastStep, apiResponse = null) {
	if ( apiResponse != null ) {

		const road_id = apiResponse.body.road_id;
		const vote_id = apiResponse.body.vote_id;

		storeRoadVoteId(road_id, vote_id);
	}

	// 2024-02-14 once the sing-step-form has been submitted,
	// we will redirect the user to the Thank You page.
	//
	let redirectUrl = buildRedirectUrl(currentStep, currentStep);

	data = JSON.stringify(data);

	if( sessionStorage.getItem(key) ) {
		sessionStorage.removeItem(key)
	}

	// Create a new one
	sessionStorage.setItem(key, data);

	// Clear step one road data if user hits the thank page
	clearUserSession(redirectUrl, key);
	
	// Take user to the next page
	window.location.href = redirectUrl;
}

/**
 * this allows us to send the data via query string
 * @param {*} stringValue
 * @returns
 */
const hashParameters = ( stringValue ) => {
	// lastVotedOn,road_id,vote_id => 1708031801,33776,219648
	return encodeURIComponent(btoa(stringValue));
}

const buildRedirectUrl = (currentStep, lastStep) => {
	let url = `${getUrl()}${window.location.pathname}`;

	if( currentStep == lastStep || currentStep == '3') {
		url += 'thanks';

		// set lastVotedOn with the current timestamp
		const date		= getCurrentDate();
						sessionStorage.setItem("lastVotedOn", date.unix);

		// data is what is going to be hashed and eventually be sent over via the query string
		let data		= date.unix;
		const road_id	= sessionStorage.getItem('road_id');
		const vote_id	= sessionStorage.getItem('vote_id');

		// string to hash:  lastVotedOn,road_id,vote_id
		// url to generate: /clubs/{clubname}/vote/thanks/?r={road_id}&d={hashed string}
		if ( road_id !== null ) {
			url  += '?r=' + road_id;
			data += ',' + road_id;
			if ( vote_id !== null ) {
				data += ',' + vote_id;
			}
			const hashed = hashParameters(data); // url encoded
			url += '&d=' + hashed;
		}

	} else if ( currentStep > lastStep && currentStep != '2' ) {
		let nextStep = 3;
		url += `?step=${nextStep}`
	} else {
		let nextStep = Number(currentStep) + 1;
		url += `?step=${nextStep}`
	}

	return url;
}

const storeRoadVoteId = (road_id, vote_id) => {
	sessionStorage.setItem('road_id', road_id);
	sessionStorage.setItem('vote_id', vote_id);
}

const clearUserSession = (redirectUrl) => {
	if( redirectUrl.includes('thanks') ) {
		refreshSessionData();
	}

	return;
}

export function getSessionVoteId() {
	sessionStorage.removeItem('itemName');

	return sessionStorage.getItem('vote_id');
}

// Mark both step 2 and 3 completed to false
export function markStepsIncomplete() {
	let stepThreeData = JSON.parse(sessionStorage.getItem('stepThreeSession'));

	if( sessionStorage.getItem('stepTwoSession') ) {
		let stepTwoData = JSON.parse(sessionStorage.getItem('stepTwoSession'));
		stepTwoData.completed = false;
		stepTwoData = JSON.stringify(stepTwoData);

		sessionStorage.setItem('stepTwoSession', stepTwoData);
	}

	if( sessionStorage.getItem('stepThreeSession') ) {
		let stepThreeData = JSON.parse(sessionStorage.getItem('stepThreeSession'));
		stepThreeData.completed = false;
		stepThreeData = JSON.stringify(stepThreeData);

		sessionStorage.setItem('stepThreeSession', stepThreeData);
	}
}

function refreshSessionData() {
	const sessionKeys   = [ 'stepOneSession', 'stepTwoSession', 'stepThreeSession' ];

	for( let i = 0; i < sessionKeys.length; i++ ) {
		let session = sessionKeys[i];

		if( sessionStorage.getItem(session) ) {
			sessionStorage.removeItem(session);
		}
	}

	return;
}